import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import ExclusiveContainer from '../components/ExclusiveContainer'
import GeneralContainer from '../components/GeneralContainer'

export default function N25_11_06() {
  return (
    <NoteContainer date={'06/11/2025'} version="20.20.0">
      <VStack w="full">
        <GeneralContainer>
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Validação do telefone</TaskTitle>
                <TaskBreadcrumb>Geral</TaskBreadcrumb>
                <TaskDescription>Agora a validação de telefone aceita celulares e telefones fixos</TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </GeneralContainer>

        <ExclusiveContainer category="FEATURE" institutions={['teste', 'treinamento', 'agsus']}>
          <ModuleContainer moduleName="CITIZEN_PROFILE">
            <VStack w="full">
              <CategoryContainer category="ADJUSTMENTS">
                <Box>
                  <TaskTitle>Ajustes nos textos da consulta de holerite</TaskTitle>
                  <TaskBreadcrumb>Perfil/ Consultar holerite</TaskBreadcrumb>
                  <TaskDescription>Ajustes de textos</TaskDescription>
                </Box>
                <Box>
                  <TaskTitle>PDF abre de maneira automática</TaskTitle>
                  <TaskBreadcrumb>Perfil/ Consultar holerite</TaskBreadcrumb>
                  <TaskDescription>
                    Agora, caso tenha um arquivo PDF, o mesmo será aberto de maneira automática no navegador do usuário
                  </TaskDescription>
                </Box>
              </CategoryContainer>
            </VStack>
          </ModuleContainer>
        </ExclusiveContainer>

        <ModuleContainer moduleName="ASSESSMENTS_AND_RESEARCH">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle>Alerta quando não há pessoa unificada selecionada</TaskTitle>
                <TaskBreadcrumb>Pesquisas/ Registro de pesquisa</TaskBreadcrumb>
                <TaskDescription>
                  Agora, ao abrir a janela de registro de pesquisas sem ter selecionado previamente uma pessoa
                  unificada, um alerta será gerado para reforçar ao usuário que a pesquisa não estará vinculada com
                  nenhuma pessoa
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Alerta quando a pessoa selecionada é o próprio usuário</TaskTitle>
                <TaskBreadcrumb>Pesquisas/ Registro de pesquisa</TaskBreadcrumb>
                <TaskDescription>
                  Agora, ao abrir a janela de registro de pesquisas tendo selecionado previamente como pessoa unificada
                  o próprio usuário, um alerta será gerado para reforçar ao usuário
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ModuleContainer moduleName="SERVICES_LETTER">
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Alteração de texto</TaskTitle>
                <TaskBreadcrumb>Serviços/ Perfil do serviço/ Reguladores</TaskBreadcrumb>
                <TaskDescription>Alterações de textos</TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Edição das ações do regulador</TaskTitle>
                <TaskBreadcrumb>Serviços/ Perfil do serviço/ Reguladores</TaskBreadcrumb>
                <TaskDescription>Correções da atualização das ações do regulador</TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
